module.exports = __webpack_public_path__ + "images/emoji/disappointed.a1c9120342a31a48e6b7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/disappointed.png
// module id = 6Hq7
// module chunks = 2